import React, { useState }          from "react";
import { useEffect } from "react";

const IntListInput = ({onChange, name, value}) => {
    
    const initVal = value?.reduce((prev, curr, index) => (index? ('' + prev + ','): '') + curr, '');

    useEffect(() => {
        if (initVal) setValueSt(initVal);
    }, [initVal]);

    const [valueSt, setValueSt] = useState('');

    const handleBlur = e => {

         const value = valueSt.split(',')
            .map(s=>Number.parseInt(s))
            .filter(i => !isNaN(i)); // Fixed: Keep valid numbers, not NaN values

         onChange( { target: { name, value: value } } );
    }


    return <input type="text" name={name} value={valueSt}
                onChange={e => setValueSt(e.target.value)} onBlur={handleBlur} size='20'/>
}

export default IntListInput;